var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M339.147,189.217h-33.494c0.277,3.681,0.434,7.395,0.434,11.13c0,24.764-6.19,48.767-16.981,65.853 c-3.329,5.27-8.923,12.712-16.411,17.732v-94.716h-33.391v94.716c-7.487-5.02-13.082-12.461-16.411-17.732 c-10.792-17.086-16.981-41.089-16.981-65.853c0-3.735,0.158-7.45,0.434-11.13h-33.494c-0.215,3.663-0.332,7.373-0.332,11.13 c0,68.656,36.668,122.435,83.478,122.435s83.478-53.779,83.478-122.435C339.478,196.59,339.361,192.88,339.147,189.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M105.739,122.435h33.391v22.261h33.391v-22.261h33.391v22.261h33.391v-22.261h33.391v22.261h33.391 v-22.261h33.391v22.261h33.391v-22.261h33.391v22.261h80.337C445.19,59.065,357.493,0,256,0S66.81,59.065,25.402,144.696h80.337 V122.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M406.261,367.304v22.261H372.87v-22.261h-33.391v22.261h-33.391v-22.261h-33.391v22.261h-33.391 v-22.261h-33.391v22.261h-33.391v-22.261H139.13v22.261h-33.391v-22.261H25.402C66.81,452.935,154.506,512,256,512 s189.19-59.065,230.598-144.696H406.261z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIr);
export default __webpack_public_path__ + "static/media/ir.854365a884b36be7da8d6bcfc1bc5852.svg";
export { ForwardRef as ReactComponent };